import { useState } from "react";
import { ImagePlus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuthedApi, imgUrl, errMsg } from "../lib/api";

export default function ImageUploader({ value, onChange, max = 12, testid = "image-uploader" }) {
  const api = useAuthedApi();
  const [busy, setBusy] = useState(false);

  const onFiles = async (files) => {
    const list = Array.from(files).slice(0, max - value.length);
    if (!list.length) return;
    setBusy(true);
    const urls = [];
    for (const f of list) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        urls.push((await api("post", "/upload", fd)).url);
      } catch (e) {
        toast.error(`${f.name}: ${errMsg(e)}`);
      }
    }
    onChange((prev) => [...prev, ...urls]);
    setBusy(false);
  };

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-3" data-testid={testid}>
      {value.map((u, i) => (
        <div key={u} className="relative aspect-square rounded-xl overflow-hidden border border-[#D4AF37]/30">
          <img src={imgUrl(u)} alt="" className="w-full h-full object-cover" />
          {i === 0 && max > 1 && <span className="absolute bottom-1 left-1 text-[9px] uppercase bg-black/70 text-[#E5C158] px-1.5 py-0.5 rounded">Cover</span>}
          <button type="button" onClick={() => onChange((prev) => prev.filter((x) => x !== u))} className="absolute top-1 right-1 bg-black/70 rounded-full p-1 hover:bg-red-600 transition-colors" data-testid={`${testid}-remove-${i}`}>
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
      {value.length < max && (
        <label className="aspect-square rounded-xl border border-dashed border-[#D4AF37]/50 flex flex-col items-center justify-center gap-1 cursor-pointer hover:bg-[#D4AF37]/5 transition-colors text-[#E5C158] text-xs">
          {busy ? <Loader2 className="w-6 h-6 animate-spin" /> : <ImagePlus className="w-6 h-6" />}
          {busy ? "Uploading" : "Add photo"}
          <input type="file" accept="image/jpeg,image/png,image/webp" multiple={max > 1} className="hidden" disabled={busy} data-testid={`${testid}-input`} onChange={(e) => { onFiles(e.target.files); e.target.value = ""; }} />
        </label>
      )}
    </div>
  );
}
